import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { trackVideoEvent } from './VideoPlayerAnalytics';
import VideoPoster from './VideoPoster';

class VideoPlayerBasic extends Component {
  constructor(props) {
    super(props);
    this.state = { started: false };
    this.handlePosterClick = this.handlePosterClick.bind(this);
    this.onVideoEnd = this.onVideoEnd.bind(this);
    this.videoNode = React.createRef();
  }

  componentDidUpdate() {
    const { shouldPause } = this.props;
    if (shouldPause && this.videoNode.current) {
      this.videoNode.current.pause();
    }
  }

  onVideoEnd() {
    const { onEnded } = this.props;
    onEnded();
  }

  handlePosterClick() {
    this.setState({ started: true });
  }

  renderVideo() {
    const { onStart, poster, videoURL, style } = this.props;
    const videoStyle = style || { maxHeight: '46vh' };
    return (
      <div className="video-player-basic">
        <video
          ref={this.videoNode}
          poster={poster}
          src={videoURL}
          autoPlay
          controls
          className="w-100 bg-black"
          controlsList="nodownload"
          onLoadStart={onStart}
          onEnded={this.onVideoEnd}
          onError={this.onVideoError}
          style={videoStyle}
          data-id="video-player-basic"
        />
      </div>
    );
  }

  render() {
    const { started } = this.state;
    const { poster, hidePoster } = this.props;
    if (started || hidePoster) {
      return this.renderVideo();
    }
    return <VideoPoster onClick={this.handlePosterClick} poster={poster} />;
  }
}

VideoPlayerBasic.propTypes = {
  onEnded: PropTypes.func,
  onStart: PropTypes.func,
  poster: PropTypes.string,
  shouldPause: PropTypes.bool,
  videoURL: PropTypes.string,
  hidePoster: PropTypes.bool,
  style: PropTypes.shape({}),
};

VideoPlayerBasic.defaultProps = {
  onEnded: () => {},
  onStart: () => {},
  poster: '',
  shouldPause: false,
  videoURL: '',
  hidePoster: false,
  style: null,
};

export default VideoPlayerBasic;
